import { startOfDay } from 'date-fns';
import { DateObject } from 'react-multi-date-picker';
import { DateRangePickerValue } from 'shared/mui/DatePicker/DateTimeRangePicker/DateTimeRangePicker';

import { setCurrentTime } from './setCurrentTime';

export function getValidCalendarDate(
  date: DateObject | null,
  time?: DateRangePickerValue,
): number | null {
  if (date) {
    return time ? setCurrentTime(date.valueOf(), time) : Number(startOfDay(date.valueOf()));
  }

  return null;
}
